import React from 'react';
import './PrivacyStatment.css';

const PrivacyStatment = props => {
  return (
    <div className="privacy-stmt-wrapper" style={props.type === "vuma" ? { background: "transparent", marginTop: "1rem" } : null}>
      <hr className="progress__hr" style={props.type === "vuma" ? { display: "none" } : null} />
      <div className="privacy-statments">
        <div className="privacy-image">
          <img automationid="SalesLead_IMG_DigiSSLImage_0" src="/cloud/fibre/sales/Assets/DigiSSL.png" alt="/cloud/fibre/sales/Assets/DigiSSL.png" />
        </div>
        <div className="privacy-stmt-section">
          <div className="privacy-stmt-heading" automationid="SalesLead_Div_privacyImportantToUsHeading_0">Your privacy is important to us</div>
          <div className="privacy-stmt-desc" automationid="SalesLead_P_privacyDesc_0">At Vodacom, we're committed to respecting the privacy of your personal data.</div>
          <div className="privacy-stmt-desc" automationid="SalesLead_P_privacyDesc_1">To demonstrate our commitment, we've created the
           <a href="https://www.vodacom.co.za/vodacom/privacy-policy/terms" target="_blank" automationid="SalesLead_A_privacyLink_0"> Vodacom Security and Privacy Statement </a></div>
          <div className="privacy-stmt-desc" automationid="SalesLead_P_privacyDesc_2">which communicates our intention to provide effective processes for the appropriate handling thereof and to comply with</div>
          <div className="privacy-stmt-desc marginBottom20" automationid="SalesLead_P_privacyDesc_3">applicable legislation that governs the authentication, protection and disclosure of personal information.</div>

          <div className="privacy-stmt-desc" automationid="SalesLead_P_privacyDesc_4">In accordance with this, it's important that we conduct security checks before proceeding.</div>
        </div>
        <div className="privacy-image">
          <img automationid="SalesLead_IMG_HdsImage_0" src="/cloud/fibre/sales/Assets/Hds.png" alt="/cloud/fibre/sales/Assets/Hds.png" />
        </div>
      </div>
    </div>
  )
}

export default PrivacyStatment;
